module.exports = __webpack_public_path__ + "static/img/IDaaS-icon-1.d5498d7a.svg";